import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { UserCircle, SignOut, EnvelopeSimple } from "@phosphor-icons/react";

export default function Account() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <Layout>
      <div className="mx-auto max-w-2xl px-6 py-10 sm:px-10">
        <h1 className="font-display text-4xl font-bold tracking-tight">Account</h1>
        <div className="mt-8 rounded-3xl border border-border bg-card p-8">
          <div className="flex items-center gap-4">
            <div className="grid h-16 w-16 place-items-center rounded-2xl bg-secondary"><UserCircle size={36} weight="duotone" /></div>
            <div>
              <p className="font-display text-2xl font-medium">{user?.name}</p>
              <p className="flex items-center gap-1.5 text-sm text-muted-foreground"><EnvelopeSimple size={14} /> {user?.email}</p>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="rounded-2xl bg-secondary p-4"><p className="text-xs text-muted-foreground">Role</p><p className="mt-1 font-medium capitalize">{user?.role}</p></div>
            <div className="rounded-2xl bg-secondary p-4"><p className="text-xs text-muted-foreground">Member since</p><p className="mt-1 font-medium">{user?.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}</p></div>
          </div>
          <Button variant="outline" onClick={doLogout} className="mt-8 rounded-full" data-testid="account-logout"><SignOut size={16} /> Sign out</Button>
        </div>
      </div>
    </Layout>
  );
}
